// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Jr0Xsa {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  width: 100%;
  height: 100%;
  background: var(--card-background, #ffffff);
  border-radius: var(--radius-s, 4px);
  box-shadow: var(--card-box-shadow, 0px 2px 4px 0px rgba(0, 0, 0, 0.12));
  overflow: hidden;
  margin-bottom: 30px;
}

.WDzJbx {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-2, 16px) var(--spacing-3, 24px) var(--spacing-3, 24px);
  gap: var(--spacing-3, 24px);
  flex: 1;
  min-height: 0;
}

.U9LTZp {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: var(--background-alt);
  padding-bottom: var(--spacing-3);
}

.KlsAdf {
  display: flex;
  flex: 1;
  gap: var(--spacing-3);
  min-height: 100%;
  height: 100%;
}

._4Z4JN {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.ehV9wX {
  flex: 1;
  background-color: var(--surface-neutral-white);
  width: 100%;
  height: 100%;
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: 24px;
  text-align: left;
  font-size: 14px;
  color: #1f1f1f;
  font-family: var(--font-family-base);
}

.wCiJb0 {
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: var(--surface-neutral-white);
}

.j3ubXF {
  width: 355px;
  height: 100%;
}

.RoV6Cs {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  gap: var(--spacing-2);
  background-color: var(--surface-neutral-white);
  padding: 15px;
}

.XLjNMz {
  height: 40px;
  width: 100px;
  padding-top: var(--spacing-1);
  padding-right: var(--spacing-1-5);
  padding-bottom: var(--spacing-1);
  padding-left: var(--spacing-1-5);
  border-radius: var(--button-border-radius);
  background: var(--surface-neutral-white);
  border: 2px solid var(--brand-tr-orange);
  color: var(--text-primary-medium);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  cursor: pointer;
}

.zdF1Vj {
  height: 40px;
  width: 100px;
  padding-top: var(--spacing-1);
  padding-right: var(--spacing-1-5);
  padding-bottom: var(--spacing-1);
  padding-left: var(--spacing-1-5);
  border-radius: var(--button-border-radius);
  background: var(--brand-tr-orange);
  border: 2px solid var(--brand-tr-orange);
  color: var(--text-neutral-white);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  cursor: pointer;
}
.zdF1Vj:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: var(--disabled-subtle-surface);
  color: var(--text-neutral-strong);
  border: 2px solid var(--disabled-subtle-surface);
}

.GopFSL {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 0; /* Permite que o flex item encolha */
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixTransferSteps/PixTransferSteps.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,mCAAmC;EACnC,uEAAuE;EACvE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,6EAA6E;EAC7E,2BAA2B;EAC3B,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,OAAO;EACP,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,OAAO;EACP,8CAA8C;EAC9C,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,0CAA0C;EAC1C,wCAAwC;EACxC,wCAAwC;EACxC,iCAAiC;EACjC,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,0CAA0C;EAC1C,kCAAkC;EAClC,wCAAwC;EACxC,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,aAAa,EAAE,oCAAoC;AACrD","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  align-items: stretch;\n  width: 100%;\n  height: 100%;\n  background: var(--card-background, #ffffff);\n  border-radius: var(--radius-s, 4px);\n  box-shadow: var(--card-box-shadow, 0px 2px 4px 0px rgba(0, 0, 0, 0.12));\n  overflow: hidden;\n  margin-bottom: 30px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing-2, 16px) var(--spacing-3, 24px) var(--spacing-3, 24px);\n  gap: var(--spacing-3, 24px);\n  flex: 1;\n  min-height: 0;\n}\n\n.layoutRoot {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  background: var(--background-alt);\n  padding-bottom: var(--spacing-3);\n}\n\n.layoutContent {\n  display: flex;\n  flex: 1;\n  gap: var(--spacing-3);\n  min-height: 100%;\n  height: 100%;\n}\n\n.paymentLayoutContent {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.mainContent {\n  flex: 1;\n  background-color: var(--surface-neutral-white);\n  width: 100%;\n  height: 100%;\n  position: relative;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  box-sizing: border-box;\n  gap: 24px;\n  text-align: left;\n  font-size: 14px;\n  color: #1f1f1f;\n  font-family: var(--font-family-base);\n}\n\n.footerContent {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  background-color: var(--surface-neutral-white);\n}\n\n.sideContent {\n  width: 355px;\n  height: 100%;\n}\n\n.footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 100%;\n  gap: var(--spacing-2);\n  background-color: var(--surface-neutral-white);\n  padding: 15px;\n}\n\n.backButton {\n  height: 40px;\n  width: 100px;\n  padding-top: var(--spacing-1);\n  padding-right: var(--spacing-1-5);\n  padding-bottom: var(--spacing-1);\n  padding-left: var(--spacing-1-5);\n  border-radius: var(--button-border-radius);\n  background: var(--surface-neutral-white);\n  border: 2px solid var(--brand-tr-orange);\n  color: var(--text-primary-medium);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  cursor: pointer;\n}\n\n.nextButton {\n  height: 40px;\n  width: 100px;\n  padding-top: var(--spacing-1);\n  padding-right: var(--spacing-1-5);\n  padding-bottom: var(--spacing-1);\n  padding-left: var(--spacing-1-5);\n  border-radius: var(--button-border-radius);\n  background: var(--brand-tr-orange);\n  border: 2px solid var(--brand-tr-orange);\n  color: var(--text-neutral-white);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  cursor: pointer;\n}\n.nextButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  background: var(--disabled-subtle-surface);\n  color: var(--text-neutral-strong);\n  border: 2px solid var(--disabled-subtle-surface);\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  min-height: 0; /* Permite que o flex item encolha */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Jr0Xsa`,
	"content": `WDzJbx`,
	"layoutRoot": `U9LTZp`,
	"layoutContent": `KlsAdf`,
	"paymentLayoutContent": `_4Z4JN`,
	"mainContent": `ehV9wX`,
	"footerContent": `wCiJb0`,
	"sideContent": `j3ubXF`,
	"footer": `RoV6Cs`,
	"backButton": `XLjNMz`,
	"nextButton": `zdF1Vj`,
	"loader": `GopFSL`
};
module.exports = ___CSS_LOADER_EXPORT___;
